// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"15531723","385":"36d6eecd","515":"dca5ba90","725":"8bd87a66","787":"52503e07"}[chunkId] + ".chunk.js";
};